module.exports = __webpack_public_path__ + "media/media/about/5-e3a6ba0d8c0126b9444cf2a6dc5ac796.jpg";